import { langs } from './langs';
import { loginForm } from './loginForm';
import { ThemeUICSSObject } from '@apia/theme';
const login: ThemeUICSSObject = {
  langs,
  loginForm,
};

export { login };
